export default function BrandLogo({ height = 36, alt = "TabletsTalk", style = {} }) {
  return (
    <span
      className="tt-mark"
      style={{ height, ...style }}
      aria-label={alt}
    >
      <svg width={height} height={height} viewBox="0 0 48 48" aria-hidden="true">
        <rect x="4" y="14" width="22" height="12" rx="6" fill="#1a5f4a" />
        <rect x="22" y="14" width="22" height="12" rx="6" fill="#e8f3ee" stroke="#1a5f4a" />
        <path d="M18 28 L14 38 L26 32 Z" fill="#c45c26" />
      </svg>
      <span className="tt-word">TabletsTalk</span>
    </span>
  );
}
